import React, { useState, useEffect } from "react";
import "./menu.css";
import Container from "../Container/Container";
import { NavHashLink } from "react-router-hash-link";

const Menu = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isMenuOpen]);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <div className="menu">
            <Container>
                <div className={`menu-content ${isMenuOpen ? 'menu-open' : ''}`}>
                    <h2 className="logo">DG</h2>
                    <div className={`menu-links ${isMenuOpen ? 'open' : ''}`}>
                        <NavHashLink smooth to="/#home" onClick={closeMenu}>Home</NavHashLink>
                        <NavHashLink smooth to="/#projects" onClick={closeMenu}>Projects</NavHashLink>
                        <NavHashLink smooth to="/#about" onClick={closeMenu}>About</NavHashLink>
                        <NavHashLink smooth to="/#contact" onClick={closeMenu}>Contact</NavHashLink>
                    </div>
                    <button className="hamburger" onClick={toggleMenu} aria-label="Toggle menu">
                        <span className="hamburger-line"></span>
                        <span className="hamburger-line"></span>
                        <span className="hamburger-line"></span>
                    </button>
                </div>
            </Container>
        </div>
    );
};

export default Menu;